import VAlert from './VAlert'

VAlert.install = function install (Vue) {
  Vue.component(VAlert.name, VAlert)
}

export default VAlert



// WEBPACK FOOTER //
// ./src/components/VAlert/index.js